export class ContentDuration {

    private _isInfinity: boolean;
    private _isNaN: boolean;
    private _value: number;

    constructor(duration: number) {
        this._isNaN = isNaN(duration);
        this._isInfinity = !isFinite(duration);
        this._value = duration;
        if (this._isInfinity || this._isNaN) {
            this._value = 0;
        }
    }

    get value(): number {
        return this._value;
    }

    get isNaN(): boolean {
        return this._isNaN;
    }

    get isInfinity(): boolean {
        return this._isInfinity;
    }

    set value(value: number) {
        this._value = value;
    }

    set isNaN(isNaN: boolean) {
        this._isNaN = isNaN;
    }

    set isInfinity(isInfinity: boolean) {
        this._isInfinity = isInfinity;
    }
}
